import {FC, memo} from "react";
import './VideoPlayerCenterPlayButton.css'
import classnames from "classnames";
import { IoPlay } from "react-icons/io5";

const VideoPlayerCenterPlayButtonComponent: FC<{
  visible: boolean,
  onClick: () => void,
}> = ({
  visible,
  onClick,
}) => {

  return (
    <div className={classnames("video-player-center-play-container", { "visible": visible })}>
      <IoPlay onClick={onClick} className={"video-player-center-play-button"} size={72}/>
    </div>
  )
}

export const VideoPlayerCenterPlayButton = memo(VideoPlayerCenterPlayButtonComponent)